import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface DocumentSearchCategoryModel {
    id: string;
    documentName: string;
    documentDescription: string;
    filePath: string;
    searchCategory: string;
}

export interface DocumentSearchDetailsModel {
    initialDocumentTypes: any;
    uri?: any;
    documentSearchdata: any;
    documentSearchCategories: DocumentSearchCategoryModel[];
    pagination?: PaginationModel | undefined;
    searchCategories?: string[] | any;
    isLoading: boolean;
}

const docSearchDataUrl = "/api/v1/documentsearchcategory";

export interface DocumentSearchParameters extends ApiParameter {
    initialDocumentTypes?: string;
    query?: string;
    searchCategoryFilter?: string;
    page: number;
    pageSize: number;
    sort: string | boolean;
}

export async function getDocumentSearchList(
    parameter: DocumentSearchParameters
) {
    const docSearchDataModel = await get<DocumentSearchDetailsModel>(docSearchDataUrl, parameter);
    return docSearchDataModel;
}